import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

import LogotypeInput from "components/InputsField/LogotypeInput";
import ModalWindow from "../../ModalWindow";
import Loading from "../../Loading";
import { CompanyLogo } from "components/common/CompanyLogo";
import PopupTitle from "components/common/PopupTitle";
import InputError, { ERROR_PLACE } from "components/InputsField/InputError";

import styles from "./styles.module.scss";

const EditLogo = ({ onClose, editLogo }) => {
    const { t } = useTranslation();

    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [responseErrors, setResponseErrors] = useState([]);
    const [fileError, setFileError] = useState(null);

    const closeCallback = useCallback(() => {
        setLoading(false);
        onClose();
    }, [onClose]);

    const handleSubmit = useCallback(
        (event) => {
          console.log('files', files);
          if (Array.isArray(files) && !files.length) {
            onClose();
            return;
          }
          event.preventDefault();

          setLoading(true);

          let formData = new FormData();
          formData.append('logo', files ? files.file : null);

          editLogo(formData, closeCallback)
            .catch((e) => {
              setResponseErrors(e.response.data.errors);
            })
            .finally(() => {
              setLoading(false);
            });
        },
        [closeCallback, editLogo, files, onClose],
    );

    return (
        <div className="contact__wrapper">
            <div className={styles.container}>
                <PopupTitle title={t("logo.heading")} />
                <div className={styles.logoWrapper}>
                    <LogotypeInput
                        onChange={setFiles}
                        setError={setFileError}
                        errorMessage={fileError}
                        errorMode={ERROR_PLACE.static}
                    />
                </div>
                {responseErrors.length > 0 &&
                    responseErrors.map((error, index) => (
                        <InputError key={index} message={t(error.type)} mode={ERROR_PLACE.static} />
                    ))}
                {!loading ? (
                    <div>
                        <button
                            className="popup__button new-payment__button"
                            type="button"
                            onClick={handleSubmit}
                        >
                            {t("logo.saveButton")}
                        </button>
                    </div>
                ) : (
                    <Loading />
                )}
            </div>
            <button className="popup__close-button" type="button" onClick={onClose} />
        </div>
    );
};

function EditLogoModal({ editLogo, mode }) {
    return (
        <ModalWindow
            WindowComponent={EditLogo}
            ButtonComponent={CompanyLogo}
            editLogo={editLogo}
            mode={mode}
        />
    );
}

export default EditLogoModal;
